import React, { useEffect, useRef, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { Icons, Tab, Tabs, Box } from "@curves/ui-base";
import { CLUB_DATA_ANALYSIS_ROUTER } from '@icoach/router/routerPath';
import { parseDate } from '@util/moment';
import DataAnalysisContentMembership from './DataAnalysisContentMembership';
import DataAnalysisContentTaskMatter from './DataAnalysisContentTaskMatter';
import DataAnalysisContentService from './DataAnalysisContentService';
import DataAnalysisContentEmployees from './DataAnalysisContentEmployees';
import DataAnalysisContentGuestProduction from './DataAnalysisContentGuestProduction';
import DataAnalysisContentSales from './DataAnalysisContentSales';
import DataAnalysisContentKpi from './DataAnalysisContentKpi';
import DataAnalysisDialogBox from '@icoach/dataAnalysis/dialog/DataAnalysisDialogBox';

const DataAnalysisPage = () => {
    const { tabs } = useParams();
    const [tabsIndex, setTabsIndex] = useState('');
    const searchDateRef = React.useRef(parseDate());
    const dialogRef = useRef(null);
    const handleTabChange = (_, value) => {
        setTabsIndex(value);
    };

    useEffect(
        () => {
            let tabsPath = tabs;
            if (!tabs) {
                tabsPath = 'goal';
            }
            setTabsIndex(tabsPath);
        },
        // eslint-disable-next-line
        []
    );

    return (
        <Box className="container main-container-spacing">
            <Box className="page-tabs tabs-bottom-line mb-4">
                <Tabs value={tabsIndex} onChange={handleTabChange}>
                    <Tab
                        className={'py-3'}
                        label={'目標進度'}
                        value={'goal'}
                        icon={<Icons.Developer />}
                        component={NavLink}
                        to={CLUB_DATA_ANALYSIS_ROUTER.GOAL}
                    />
                    <Tab
                        className={'py-3'}
                        label={'會籍'}
                        value={'membership'}
                        icon={<Icons.UserAlt />}
                        component={NavLink}
                        to={CLUB_DATA_ANALYSIS_ROUTER.MEMBERSHIP}
                    />
                    <Tab className={'py-3'} label={'服務'} value={'service'} icon={<Icons.Star />} component={NavLink} to={CLUB_DATA_ANALYSIS_ROUTER.SERVICE} />
                    <Tab
                        className={'py-3'}
                        label={'顧客製造'}
                        value={'guest-production'}
                        icon={<Icons.UserPlus />}
                        component={NavLink}
                        to={CLUB_DATA_ANALYSIS_ROUTER.GUEST_PRODUCTION}
                    />
                    <Tab className={'py-3'} label={'非會籍'} value={'sales'} icon={<Icons.ChartPie />} component={NavLink} to={CLUB_DATA_ANALYSIS_ROUTER.SALES} />
                    <Tab
                        className={'py-3'}
                        label={'教練'}
                        value={'employees'}
                        icon={<Icons.Store />}
                        component={NavLink}
                        to={CLUB_DATA_ANALYSIS_ROUTER.EMPLOYEES}
                    />
                    <Tab
                        className={'py-3'}
                        label={'管理'}
                        value={'task-matter'}
                        icon={<Icons.ListUl />}
                        component={NavLink}
                        to={CLUB_DATA_ANALYSIS_ROUTER.TASK_MATTER}
                    />
                </Tabs>
            </Box>
            {tabsIndex === 'goal' && <DataAnalysisContentKpi defaultDate={searchDateRef} dialogRef={dialogRef} />}
            {tabsIndex === 'membership' && <DataAnalysisContentMembership defaultDate={searchDateRef} dialogRef={dialogRef} />}
            {tabsIndex === 'service' && <DataAnalysisContentService defaultDate={searchDateRef} dialogRef={dialogRef} />}
            {tabsIndex === 'guest-production' && <DataAnalysisContentGuestProduction defaultDate={searchDateRef} dialogRef={dialogRef} />}
            {tabsIndex === 'sales' && <DataAnalysisContentSales defaultDate={searchDateRef} dialogRef={dialogRef} />}
            {tabsIndex === 'employees' && <DataAnalysisContentEmployees defaultDate={searchDateRef} dialogRef={dialogRef} />}
            {tabsIndex === 'task-matter' && <DataAnalysisContentTaskMatter dialogRef={dialogRef} />}
            <DataAnalysisDialogBox ref={dialogRef} />
        </Box>
    );
};

export default DataAnalysisPage;
